"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createAutoCancellation = void 0;
var NO_LOAD = Error("autoCancellation.wasm is not ready, make sure you have completed load().");
var runResolve = null;
var runReject = null;
var running = false;
var log = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return console.log.apply(console, __spreadArrays(["🐍[core-log]"], args));
};
//config
var defaultArgs = [];
var defaultOpts = {
    path: "https://aw-public-abroad.oss-us-west-1.aliyuncs.com/newNuroum/lib/createAutoCancellationCore.js",
};
function createAutoCancellation(options) {
    if (options === void 0) { options = defaultOpts; }
    var autoCancellation = null;
    var Core = null;
    function load() {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, loadScript(options.path, "createAutoCancellationCore")];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, window.createAutoCancellationCore({
                                printErr: function (message) { return parseMessage({ type: "fferr", message: message }); },
                                print: function (message) { return parseMessage({ type: "ffout", message: message }); },
                            })];
                    case 2:
                        Core = _a.sent();
                        autoCancellation = Core.cwrap("main", "number", ["number", "number"]);
                        console.log("🚀 -> file: createAutoCancellation.js:26 -> run -> Core", Core);
                        return [2 /*return*/];
                }
            });
        });
    }
    function run() {
        var _args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            _args[_i] = arguments[_i];
        }
        log("info", "run autoCancellation command: " + _args.join(" "));
        if (Core === null) {
            throw NO_LOAD;
        }
        else if (running) {
            throw Error("autoCancellation.wasm can only run one command at a time");
        }
        else {
            running = true;
            return new Promise(function (resolve, reject) {
                var args = __spreadArrays(defaultArgs, _args).filter(function (s) { return s.length !== 0; });
                runResolve = resolve;
                runReject = reject;
                autoCancellation.apply(void 0, parseArgs(Core, args));
            });
        }
    }
    /*
     * Run FS operations.
     * For input/output file of ffmpeg.wasm, it is required to save them to MEMFS
     * first so that ffmpeg.wasm is able to consume them. Here we rely on the FS
     * methods provided by Emscripten.
     *
     * Common methods to use are:
     * ffmpeg.FS('writeFile', 'video.avi', new Uint8Array(...)): writeFile writes
     * data to MEMFS. You need to use Uint8Array for binary data.
     * ffmpeg.FS('readFile', 'video.mp4'): readFile from MEMFS.
     * ffmpeg.FS('unlink', 'video.map'): delete file from MEMFS.
     *
     * For more info, check https://emscripten.org/docs/api_reference/Filesystem-API.html
     *
     */
    var FS = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        log("info", "run FS." + method + " " + args
            .map(function (arg) {
            return typeof arg === "string"
                ? arg
                : "<" + arg.length + " bytes binary file>";
        })
            .join(" "));
        if (Core === null) {
            throw NO_LOAD;
        }
        else {
            var ret = null;
            try {
                ret = (_a = Core.FS)[method].apply(_a, args);
            }
            catch (e) {
                if (method === "readdir") {
                    throw Error("ffmpeg.FS('readdir', '" + args[0] + "') error. Check if the path exists, ex: ffmpeg.FS('readdir', '/')");
                }
                else if (method === "readFile") {
                    throw Error("ffmpeg.FS('readFile', '" + args[0] + "') error. Check if the path exists");
                }
                else {
                    throw Error("Oops, something went wrong in FS operation.");
                }
            }
            return ret;
        }
    };
    /*
     * Determine whether the Core is loaded.
     */
    var isLoaded = function () { return Core !== null; };
    return {
        load: load,
        run: run,
        isLoaded: isLoaded,
        FS: FS,
    };
}
exports.createAutoCancellation = createAutoCancellation;
function parseArgs(Core, args) {
    var argsPtr = Core._malloc(args.length * Uint32Array.BYTES_PER_ELEMENT);
    console.log("🚀 -> file: createAutoCancellation.js:107 -> parseArgs -> argsPtr", argsPtr);
    args.forEach(function (s, idx) {
        var sz = Core.lengthBytesUTF8(s) + 1;
        var buf = Core._malloc(sz);
        Core.stringToUTF8(s, buf, sz);
        Core.setValue(argsPtr + Uint32Array.BYTES_PER_ELEMENT * idx, buf, "i32");
    });
    return [args.length, argsPtr];
}
function detectCompletion(message) {
    if (message === "AUDIOU_END" && runResolve !== null) {
        runResolve();
        runResolve = null;
        runReject = null;
        running = false;
    }
}
var parseMessage = function (_a) {
    var type = _a.type, message = _a.message;
    log(type, message);
    //   parseProgress(message, progress);
    detectCompletion(message);
};
function loadScript(path, id) {
    return new Promise(function (resolve, reject) {
        if (document.querySelector("#" + id)) {
            log("loaded", "already loaded");
            return resolve(true);
        }
        var script = document.createElement("script");
        script.id = id;
        script.src = path;
        document.body.append(script);
        script.onload = function () {
            resolve(true);
        };
        script.onerror = function () {
            log("loaded", "remote script loaded error");
            reject(false);
        };
    });
}
//# sourceMappingURL=createAutoCancellation.js.map